import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Health"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getHealthGeneral: build.query<
        GetHealthGeneralApiResponse,
        GetHealthGeneralApiArg
      >({
        query: () => ({ url: `/Health/General` }),
        providesTags: ["Health"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as healthApi };
export type GetHealthGeneralApiResponse = /** status 200 OK */ number;
export type GetHealthGeneralApiArg = void;
export const { useGetHealthGeneralQuery, useLazyGetHealthGeneralQuery } =
  injectedRtkApi;
